import type { VirtualClassroomResDto } from "@/features/education-catalog/types/virtual-classroom.types";
import type { PlanningGroupFromApi } from "../types/request-and-approval.types";
import { getPlanningGroupVirtualClassroomId } from "../types/request-and-approval.types";

function sameScheduleDate(a?: string | null, b?: string | null): boolean {
  const x = a?.trim();
  const y = b?.trim();
  if (!x || !y) return false;
  const ta = Date.parse(x);
  const tb = Date.parse(y);
  if (!Number.isNaN(ta) && !Number.isNaN(tb) && ta === tb) return true;
  return x.slice(0, 10) === y.slice(0, 10);
}

/**
 * planning-groups yanıtı Swagger’da sanal sınıf id’si içermeyebilir.
 * Bu durumda eğitime ait sanal sınıf listesi ile (jitsiRoomName, ad, tarih) eşleştirir.
 */
export function resolvePlanningGroupVirtualClassroomId(
  g: PlanningGroupFromApi,
  virtualClassrooms: VirtualClassroomResDto[],
): string | undefined {
  const direct = getPlanningGroupVirtualClassroomId(g);
  if (direct) return direct;

  const jitsi = g.jitsiRoomName?.trim();
  if (jitsi) {
    const byJitsi = virtualClassrooms.find(
      (v) => (v.jitsiRoomName?.trim() ?? "") === jitsi,
    );
    if (byJitsi) return byJitsi.id;
  }

  const name = g.name?.trim();
  if (name) {
    const byName = virtualClassrooms.filter(
      (v) => (v.name?.trim() ?? "") === name,
    );
    if (byName.length === 1) return byName[0].id;
  }

  const s = g.startDate;
  const e = g.endDate;
  if (s?.trim() && e?.trim()) {
    const byRange = virtualClassrooms.filter(
      (v) =>
        sameScheduleDate(v.startDate, s) && sameScheduleDate(v.endDate, e),
    );
    if (byRange.length === 1) return byRange[0].id;
    if (byRange.length > 1) {
      const pl = g.presetLocationId?.trim() ?? "";
      const loc = g.location?.trim() ?? "";
      const narrowed = byRange.filter(
        (v) =>
          (v.presetLocationId?.trim() ?? "") === pl &&
          (v.location?.trim() ?? "") === loc,
      );
      if (narrowed.length === 1) return narrowed[0].id;
    }
  }

  return undefined;
}
